import { createAction } from '@reduxjs/toolkit';

export const setGoogleLogin = createAction<{ googleLogin: boolean }>('config/SET_GOOGLE_LOGIN');
export const setTwitterLogin = createAction<{ twitterLogin: boolean }>('config/SET_TWITTER_LOGIN');
export const setFacebookLogin = createAction<{ facebookLogin: boolean }>('config/SET_FACEBOOK_LOGIN');
export const setWechatLogin = createAction<{ wechatLogin: boolean }>('config/SET_WECHAT_LOGIN');
export const setEmailLogin = createAction<{ emailLogin: boolean }>('config/SET_EMAIL_LOGIN');
export const setCustomTokenLogin = createAction<{ customTokenLogin: boolean }>('config/SET_CUSTOM_TOKEN_LOGIN');
